import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'documentSourceTypeName'
})
@Injectable({
  providedIn: 'root'
})
export class DocumentSourceTypeName implements PipeTransform {

  transform(sourceType: string): string {
    switch (sourceType) {
      case 'MIGRATED':
        return 'migrací';
      case 'EPD':
        return 'v EPD';
      case 'MPV':
        return 'v MPV';
      case 'MPV_GENERATED':
        return 'generováním v MPV';
      case 'MPV_EDITED':
        return 'editací v MPV';
      case 'MPV_INSERTED':
        return 'vložením v MPV';
      default:
        return '-';
    }
  }
}
